import { FormControl, FormControlLabel, FormHelperText, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, StepConnector, stepConnectorClasses, styled, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { inputTypes } from "../RegistrationSetup/helper";
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import CustomCheckbox from "../../CustomComponents/CustomCheckbox/CustomCheckbox";
import { GrContactInfo } from "react-icons/gr";
import dayjs from "dayjs";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { RiSecurePaymentLine } from "react-icons/ri";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import CustomPlaceAutocomplete from "../../CustomComponents/CustomPlaceAutocomplete";
import PhoneInput from "react-phone-input-2";

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    // Push the connector line down so it sits between icons in vertical mode
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    // When the step is active ⇒ gradient on the line
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient(to right top, #42840c, #619d25, #81b63a, #a0d150, #c1eb65)',
        },
    },
    // When the step is completed ⇒ same gradient on the line
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient(to right top, #42840c, #619d25, #81b63a, #a0d150, #c1eb65)',

        },
    },
    // Base style for the vertical line
    [`& .${stepConnectorClasses.line}`]: {
        // height controls how long the vertical line is between icons
        height: '15dvh',
        border: 0,
        width: '5px',
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
        position: 'relative',
        left: '10px',
        // if you want to switch to a dark‐mode grey, you can use theme.applyStyles:
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
}));
export const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    padding: 0,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[700],
    }),
    variants: [
        {
            props: ({ ownerState }) => ownerState?.active,
            style: {
                backgroundImage: 'linear-gradient(to right top, #42840c, #619d25, #81b63a, #a0d150, #c1eb65)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState?.completed,
            style: {
                backgroundImage: 'linear-gradient(to right top, #42840c, #619d25, #81b63a, #a0d150, #c1eb65)',
            },
        },
    ],
}));
export function ColorlibStepIcon(props) {
    const { active, completed, className } = props;

    const icons = {
        1: <GrContactInfo style={{ fontSize: '1.5rem', color: 'black' }} />,
        2: <RiMoneyDollarCircleLine style={{ fontSize: '1.5rem', color: 'black' }} />,
        3: <IoShieldCheckmarkOutline style={{ fontSize: '1.5rem', color: 'black' }} />,
        4: <RiSecurePaymentLine style={{ fontSize: '1.5rem', color: 'black' }} />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}
export const getFormattedDate = (date) => {
    if (typeof date === 'string') {
        return date;
    } else {
        return `${date.$y}-${String(Number(date.$M) + 1).padStart(2, '0')}-${String(date.$D).padStart(2, '0')}`
    }
}
export const getFieldName = (fieldDetails) => {
   // console.log("fieldDetails", fieldDetails);
    const parsedField = JSON.parse(fieldDetails.metadata);
    if (parsedField.bindWith) {
        return parsedField.bindWith;
    }
    return fieldDetails?.name.replaceAll(" ", "_")?.toLowerCase();
};
export const getFieldsByType = (fieldDetails, handleCollectData, formData = {}, isDisable = false, error = {}) => {
    const fieldName = getFieldName(fieldDetails);

    switch (fieldDetails.type) {
        case inputTypes.text:
            return (
                <TextField
                    error={error[fieldName]}
                    helperText={error[fieldName] && error[fieldName]}
                    name={fieldName}
                    value={formData[fieldName]}
                    required={fieldDetails?.isRequired}
                    className={styles['form_text_field_theme']}
                    fullWidth
                    disabled={isDisable}
                    type={fieldDetails.type}
                    onChange={(place) => handleCollectData(event, fieldDetails?.sectionId)}
                    label={fieldDetails.name} />
            );
        case inputTypes.address:
            return (
                <CustomPlaceAutocomplete
                    error={error[fieldName]}
                    helperText={error[fieldName] && error[fieldName]}
                    label={fieldDetails.name}
                    value={formData[fieldName]}
                    variant="outlined"
                    disabled={isDisable}
                    isRequired={fieldDetails?.isRequired}
                    onChange={(place) => handleCollectData({ target: { name: fieldName, value: place } }, fieldDetails?.sectionId)}
                />
            );
        case inputTypes.email:
            return (
                <TextField
                    error={error[fieldName]}
                    helperText={error[fieldName] && error[fieldName]}
                    name={fieldName}
                    value={formData[fieldName]}
                    required={fieldDetails?.isRequired}
                    className={styles['form_text_field_theme']}
                    fullWidth
                    disabled={isDisable}
                    type={fieldDetails.type}
                    onChange={(event) => handleCollectData(event, fieldDetails?.sectionId)}
                    label={fieldDetails.name} />
            );
        case inputTypes.number:
            return (
                <TextField
                    error={error[fieldName]}
                    helperText={error[fieldName] && error[fieldName]}
                    name={fieldName}
                    value={formData[fieldName]}
                    required={fieldDetails?.isRequired}
                    className={styles['form_text_field_theme']}
                    fullWidth
                    disabled={isDisable}
                    type={fieldDetails.type}
                    onChange={(event) => handleCollectData(event, fieldDetails?.sectionId)}
                    label={fieldDetails.name} />
            );
        case inputTypes.mobile:
            return (
                <PhoneInput
                    country={'us'}
                    containerClass={`phone-container ${error[fieldName] ? "error" : ""}`}
                    inputClass="phone-input"
                    inputProps={{
                        name: fieldName,
                        required: fieldDetails?.isRequired,
                        autoFocus: true,
                    }}
                    inputStyle={{
                        
                    }}
                    disableDropdown={true}
                    value={formData[fieldName] || ''}
                    onChange={(val, e) => handleCollectData({ target: { name: fieldName, value: val } }, fieldDetails?.sectionId)}
                />
            );
        case inputTypes.radio:
            return (
                <FormControl
                    error={error[fieldName]}
                    fullWidth>
                    <FormLabel required={fieldDetails?.isRequired} sx={{
                        '&.Mui-focused': {
                            color: 'var(--hoverColorBold)', // checked color
                        }
                    }} id="demo-radio-buttons-group-label">{fieldDetails?.name}</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        name={fieldName}
                        onChange={(event) => handleCollectData(event, fieldDetails?.sectionId)}
                        value={formData[fieldName]}

                    >
                        {JSON.parse(fieldDetails?.metadata)?.options?.map((op, index) =>
                            <FormControlLabel value={op?.toLowerCase()} key={index} control={<Radio
                                sx={{
                                    '&.Mui-checked': {
                                        color: 'var(--hoverColorBold)', // checked color
                                    },
                                    '&.Mui-checked ~ .MuiFormControlLabel-label': {
                                        color: 'var(--hoverColorBold)',
                                    },
                                }} />} label={op} />)}
                    </RadioGroup>
                    {error[fieldName] && (
                        <FormHelperText sx={{ color: "red", m: 0, p: 0 }}>
                            {error[fieldName]}
                        </FormHelperText>
                    )}
                </FormControl>
            );
        case inputTypes.dropdown:
            return (
                <FormControl fullWidth data-testid="game-dropdown"
                    error={error[fieldName]}
                    className={styles['form_dropdown_input_theme']}>
                    <InputLabel required={fieldDetails?.isRequired} id="demo-simple-select-autowidth-label">{fieldDetails?.name}</InputLabel>
                    <Select
                        value={formData[fieldName] ?? ''}
                        name={fieldName}
                        onChange={(event) => handleCollectData(event, fieldDetails?.sectionId)}
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        fullWidth
                        label={fieldDetails?.name}
                        disabled={isDisable}
                    >
                        {JSON.parse(fieldDetails?.metadata)?.options?.map((op, index) =>
                            <MenuItem key={index} value={op?.toLowerCase()}>{op}</MenuItem>
                        )}

                    </Select>
                    {error[fieldName] && (
                        <FormHelperText sx={{ color: "red" }}>
                            {error[fieldName]}
                        </FormHelperText>
                    )}
                </FormControl>
            );
        case inputTypes.date:
            return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        className={styles['form_date_picker_theme']}
                        label={fieldDetails?.name + " *"}
                        value={dayjs(formData[fieldName]) ?? null}
                        onChange={(event) => handleCollectData({ target: { name: fieldDetails.name.replaceAll(" ", "_")?.toLowerCase(), value: getFormattedDate(event) } }, fieldDetails?.sectionId)}
                        disabled={isDisable}
                        sx={{ width: "100%" }}
                    />
                </LocalizationProvider>
            )
        case inputTypes.checkbox:
            return (
                <CustomCheckbox
                    error={error[fieldName]}
                    name={fieldName}
                    value={formData[fieldName]}
                    onChange={(event) => handleCollectData({ target: { name: fieldDetails.name.replaceAll(" ", "_")?.toLowerCase(), value: event.target.checked } }, fieldDetails?.sectionId)}
                    label={fieldDetails?.name} />
            );
        case inputTypes.file:
            return (
                <div className={styles['registration_form_file_input']}>
                    <label htmlFor="form_file_input_btn_">{fieldDetails?.name}</label>
                    <input type="file" id="form_file_input_btn_" />
                </div>
            );
        default:
            return null;
    }
}